module.exports = __webpack_public_path__ + "img/portable-speaker-2.2b0131d6.png";